import { InputAdornment, TextField, Button, Box } from "@mui/material";
import { Search } from "@mui/icons-material";
import React, { ChangeEvent, useEffect, useState } from "react";
import useDebounce from "../../hooks/useDebounce";

interface Props {
    onChange: Function;
    showBuilder?: Function;
    id?: string;
}

const SearchBar = (props: Props) => {
    const [value, setValue] = useState<string>('')
    const debouncedValue = useDebounce<string>(value, 500)

    const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
        setValue(event.target.value)
    }

    // Fetch API (optional)
    useEffect(() => {
        // Do fetch here...
        // Triggers when "debouncedValue" changes
        props.onChange(debouncedValue);
    }, [debouncedValue])

    return (
        <Box sx={{ display: 'flex', width: '100%', gap: 2 }}>
            <TextField
                id={props?.id}
                size="small"
                fullWidth={true}
                label="search"
                value={value}
                onChange={handleChange}
                sx={{
                    background: 'white',
                    marginTop: 0
                }}
                InputProps={{
                    startAdornment: (
                        <InputAdornment position={"start"}>
                            <Search fontSize="small" />
                        </InputAdornment>
                    )
                }}
            />
            <Box id='gridAdvancedSearch' style={{ display: 'none' }}></Box>
            {props.showBuilder && <Button
                id="advancedFilterBuilderButton"
                onClick={() => props.showBuilder && props.showBuilder()}
                sx={{ px: 4, lineHeight: '1.5', whiteSpace: "nowrap" }}
                size="small"
                variant='contained'
            >
                Advanced Filter
            </Button>}
        </Box>
    )
}

export default SearchBar;